<div *ngIf="hideCommercialDiscount || (!hideCommercialDiscount && commercialDiscounts?.length)" class="sc-payment-methods-summary">
    <sc-payment-method-floating
        [disabled]="disabled"
        [loading]="loading"
        [paymentMethod$]="selectedPaymentMethod$"
        [productsData]="paymentMethodFloatingProducts"
        (primaryButtonClicked)="handlePrimaryButtonClicked($event)"
        (secondaryButtonClicked)="handleSecondaryButtonClicked($event)"
        (linkClicked)="handleLinkClicked()"
        [infoMessage]="infoMessage"
    ></sc-payment-method-floating>
    <sc-payment-methods-modal #modalElement
        [paymentMethods$]="paymentMethods$"
        [hideCommercialDiscount]="hideCommercialDiscount"
        [defaultPaymentTypeId]="selectedPaymentMethod$.value.paymentTypeId"
        [feeOptions]="feeOptions"
        [defaultFeeKey]="selectedPaymentMethod$.value.quoteNro"
        [commercialDiscounts]="commercialDiscounts"
        [defaultCommercialDiscountId]="defaultCommercialDiscountId"
        [premiumDiscountLimit]="premiumDiscountLimit"
        [hasAffinityGroupSelected]="hasAffinityGroupSelected"
        (recalculate)="handleRecalculate($event)"
        (applyChanges)="handleApplyModalChanges($event)"
        (hasUnderWriting)="handlePaymentModalUnderWriting($event)"
	></sc-payment-methods-modal>
</div>
